import { Routes } from '@angular/router';
import { IndexComponentPage } from './pages/index/index.component';
import { IndexComponentPagev2 } from './pages/indexV2/index.component';
import { ServicesComponent } from './pages/services/services.component';
import { ContactComponent } from './pages/contact/contact.component';
import { AboutComponent } from './pages/about/about.component';
import { Error404Component } from './pages/error404/error404.component';
import { PoliciesComponentPage } from './pages/policies/policies.component';
import { CoverageComponent } from './pages/coverage/coverage.component';
export const routes: Routes = [
  { path: '', component: IndexComponentPage },
  {path: 'servicios', component: ServicesComponent},
  {path:'contacto',component:ContactComponent},
  {path:'nosotros',component:AboutComponent},
  {path:'politica-privacidad',component:PoliciesComponentPage},
  // {path:'cobertura', component: CoverageComponent},
  // {path:'solicitar-servicio',component:RequestServiceComponent},
  { path: 'v2', component: IndexComponentPagev2 },
  { path: '**', component: Error404Component }
];
